//filter/subStr.js

function subStr(value = '', len = 200) {
	return value.substring(0, len) + '...';
}

export default subStr;
